import React from "react";

const MOTION = `
.coffee-wait *{transform-box:fill-box}
.coffee-wait .cup{transform-origin:50% 100%;animation:coffee-wait-sway 5s ease-in-out infinite}
.coffee-wait .min{transform-origin:50% 100%;animation:coffee-wait-spin 40s linear infinite}
.coffee-wait .sec{transform-origin:50% 83%;animation:coffee-wait-spin 60s steps(60) infinite}
.coffee-wait .tw{transform-origin:50% 50%;animation:coffee-wait-twinkle 2.4s ease-in-out infinite}
.coffee-wait .steam{opacity:0;animation:coffee-wait-steam 3.6s ease-in-out infinite}
.coffee-wait .d1{animation-delay:1.2s}
@keyframes coffee-wait-sway{0%,100%{transform:rotate(0)}50%{transform:rotate(-2deg)}}
@keyframes coffee-wait-spin{to{transform:rotate(360deg)}}
@keyframes coffee-wait-twinkle{0%,100%{transform:scale(.5);opacity:.3}50%{transform:scale(1.1);opacity:1}}
@keyframes coffee-wait-steam{0%{opacity:0;transform:translateY(8px) scaleX(.85)}35%{opacity:.9}100%{opacity:0;transform:translateY(-18px) scaleX(1.15)}}
@media (prefers-reduced-motion:reduce){.coffee-wait *{animation:none!important}.coffee-wait .steam{opacity:.9}}
`;

const CoffeeWaitingArt = ({className}) => (
  <svg
    className={`coffee-wait ${className || ''}`}
    viewBox="0 0 200 200"
    fill="none"
    stroke="#2B3A55"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true">
    <style>{MOTION}</style>
    <defs>
      <filter id="coffeeWaitSoft"><feGaussianBlur stdDeviation=".7"/></filter>
      <linearGradient id="coffeeWaitShade" x1="0" x2="1">
        <stop offset=".55" stopColor="#fff"/>
        <stop offset="1" stopColor="#E4EAF4"/>
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="90" fill="#FFF6E5" stroke="none"/>
    <g transform="translate(58 66)">
      <circle r="26" fill="#fff"/>
      <path d="M0-19v4M19 0h-4M0 19v-4M-19 0h4" strokeWidth="2.5"/>
      <path d="M0 0l7-6" strokeWidth="3.5"/>
      <path className="min" d="M0 0v-16" stroke="#5BA8DE"/>
      <path className="sec" d="M0 4v-21" stroke="#F08A6E" strokeWidth="1.6"/>
      <circle r="2.6" fill="#2B3A55" stroke="none"/>
    </g>
    <path className="tw" d="M44 128l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" fill="#fff" strokeWidth="1.8"/>
    <g filter="url(#coffeeWaitSoft)" stroke="#CDB9A3" strokeWidth="4">
      <path className="steam" d="M120 62c-6-7 6-12 0-19s6-12 0-18"/>
      <path className="steam d1" d="M134 60c-6-7 6-12 0-19s6-12 0-18"/>
    </g>
    <ellipse cx="128" cy="176" rx="34" ry="5" fill="#2B3A55" opacity=".08" stroke="none"/>
    <g className="cup">
      <path d="M100 86h56l-7 86h-42z" fill="url(#coffeeWaitShade)"/>
      <path d="M103 114h50l-2.6 32h-44.8z" fill="#7A4A2E"/>
      <circle cx="128" cy="130" r="8" fill="#F6C343" stroke="none"/>
      <path d="M124 130l3 3 5-6" stroke="#7A4A2E" strokeWidth="2.5"/>
      <path d="M96 76h64a4 4 0 0 1 4 4v6H92v-6a4 4 0 0 1 4-4z" fill="#F08A6E"/>
      <path d="M104 76l4-8h40l4 8" fill="#F08A6E"/>
    </g>
  </svg>
);

export default CoffeeWaitingArt;
